/**
 * Footer columns: open and fixed on desktop, collapsible accordions on mobile.
 */
const query = window.matchMedia('(min-width: 750px)');
const columns = Array.from(document.querySelectorAll('.nf-fcol'));

function apply() {
  columns.forEach((column) => {
    column.open = query.matches;
  });
}

columns.forEach((column) => {
  column.querySelector('summary')?.addEventListener('click', (event) => {
    if (query.matches) event.preventDefault();
  });
});

apply();
query.addEventListener('change', apply);
